import type { OrganizationServiceAccountSummary } from '../types';

export function isServiceApiKeyExpired(
  serviceID: string,
  serviceAccounts: readonly OrganizationServiceAccountSummary[] | undefined,
): boolean {
  if (!serviceAccounts?.length) {
    return false;
  }

  const account = serviceAccounts.find((s) => s.serviceID === serviceID);
  if (!account?.invalidAfter) {
    return false;
  }

  const invalidAfterDate = new Date(account.invalidAfter);
  if (isNaN(invalidAfterDate.getTime())) {
    return false;
  }

  return new Date() > invalidAfterDate;
}
